<template>
   
   <div class="column center" style="margin-bottom: 12px;">
        <h1 class="upper ups">{{ title }}</h1>
        <p v-if="desc" class="sub">{{ desctext }}</p>   
   </div>
   
</template>
<script>

/*

    <ProjectTitle title="Jobs" desc="Something"/>
 
*/

export default {
    data: function () {return {}},
    props:{
        title: String,
        desc: [],
    },    
    computed: {
        desctext(){
            if (!this.desc) return ''
            return this.desc.join(' · ')
        }
    },
}
</script>

<style scoped>
.sub { 
    letter-spacing: 2%;     
    font-size: 10px; 
    font-weight: 500; 
    text-transform: uppercase; 
    color: var(--g5); 
    line-height: 14px; 
    margin: 0 0 6px; 
}

.ups { 
    letter-spacing: 5%;
    font-size: 36px;
    font-weight: 800;
}
</style>

